<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-html="html"></span>
</template>

<script>
export default {
  props: {
    html: {
      type: String,
      required: true,
    },
  },
}
</script>
